import {
    GET_SummaryThreatsFromMerchantControl_LOADING,
    GET_SummaryThreatsFromMerchantControl_SUCCESS,
    GET_SummaryThreatsFromMerchantControl_FAILED,
    GET_Top5TerminalIdFromMerchantControl_LOADING,
    GET_Top5TerminalIdFromMerchantControl_SUCCESS,
    GET_Top5TerminalIdFromMerchantControl_FAILED,
    GET_Top3DetectionNameFromMerchantControl_LOADING,
    GET_Top3DetectionNameFromMerchantControl_SUCCESS,
    GET_Top3DetectionNameFromMerchantControl_FAILED,
    GET_DataByDateFromMerchantControl_LOADING,
    GET_DataByDateFromMerchantControl_SUCCESS,
    GET_DataByDateFromMerchantControl_FAILED,
  } from "../types";
  
  const initialState = {
    loading: false,
    error: null,
    status : null,
    threats: null,
  
  };
  
  export const AllSummaryThreadsReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; error: any, status:any }
  ) => {
    switch (action.type) {
      case GET_SummaryThreatsFromMerchantControl_LOADING:
        return {
          ...state,
          loading: action.loading,
          error: null,
          status : action?.payload?.status
        };
      case GET_SummaryThreatsFromMerchantControl_SUCCESS:
        return {
          ...state,
          loading: false,
          threats : action.payload,
          error: null,
          status: action.status
        };
      case GET_SummaryThreatsFromMerchantControl_FAILED:
        return {
          ...state,
          loading: false,
          error: action.error,
          status :  action?.payload?.status
        };
       
      default:
        return state;
    }
  };
  

  
export const Top5TerminalIdFromMerchantControlReducer = (
  state = initialState,
  action: { type: any; loading: any; payload: any; error: any , status:any}
) => {
  switch (action.type) {
    case GET_Top5TerminalIdFromMerchantControl_LOADING:
      return {
        ...state,
        loading: action.loading,
        error: null,
        status :  action?.payload?.status
      };
    case GET_Top5TerminalIdFromMerchantControl_SUCCESS:
      return {
        ...state,
        loading: false,
        threats : action.payload,
        error: null,
        status: action.status
      };
    case GET_Top5TerminalIdFromMerchantControl_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
     
    default:
      return state;
  }
};

 
export const Top3DetectionNameFromMerchantControlReducer = (
  state = initialState,
  action: { type: any; loading: any; payload: any; error: any , status:any}
) => {
  switch (action.type) {
    case GET_Top3DetectionNameFromMerchantControl_LOADING:
      return {
        ...state,
        loading: action.loading,
        error: null,
        status :  action?.payload?.status
      };
    case GET_Top3DetectionNameFromMerchantControl_SUCCESS:
      return {
        ...state,
        loading: false,
        threats : action.payload,
        error: null,
        status: action.status
      };
    case GET_Top3DetectionNameFromMerchantControl_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
     
    default:
      return state;
  }
};

export const DataByDateFromMerchantControlReducer = (
  state = initialState,
  action: { type: any; loading: any; payload: any; error: any , status:any}
) => {
  switch (action.type) {
    case GET_DataByDateFromMerchantControl_LOADING:
      return {
        ...state,
        loading: action.loading,
        error: null,
        status :  action?.payload?.status
      };
    case GET_DataByDateFromMerchantControl_SUCCESS:
      return {
        ...state,
        loading: false,
        threats : action.payload,
        error: null,
        status :  action.status
      };
    case GET_DataByDateFromMerchantControl_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
     
    default:
      return state;
  }
};


